import { Screen } from "flemo";

import { AuthGuard } from "@/components/AuthGuard";

import { CategorySettingsSection } from "./_components/CategorySettingsSection";
import { FeedbackSection } from "./_components/FeedbackSection";
import { Header } from "./_components/Header";
import { InfoSection } from "./_components/InfoSection";
import { NotificationSettingsSection } from "./_components/NotificationSettingsSection";
import { ProfileSection } from "./_components/ProfileSection";
import { StudySettingsSection } from "./_components/StudySettingsSection";

export function SettingsPage() {
  return (
    <AuthGuard>
      <Screen>
        <main className="flex min-h-0 flex-1 flex-col overflow-hidden bg-muted pt-safe">
          <Header />

          <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto overscroll-none pb-16 px-5 scrollbar-hidden">
            <ProfileSection />
            <CategorySettingsSection />
            <StudySettingsSection />
            <NotificationSettingsSection />
            <FeedbackSection />
            <InfoSection />
          </div>
        </main>
      </Screen>
    </AuthGuard>
  );
}
